export enum SortOrders {
  ASC = 'asc',
  DESC = 'desc',
}
